import {
    grey25,
    greyishBlue100,
    greyishBlue200,
    black400,
    black500,
    blue500,
    blue600,
} from "assets/jss/main";

const filterMenuStyle = () => ({
    filterMenu:{
        display: "inline-flex",
        maxWidth: "100%",
        padding: "2px",
        backgroundColor: grey25,
        border: `1px solid ${greyishBlue100}`,
        borderRadius: "10px",
        marginBottom: "24px",
    },
    tabsRoot: {
        minHeight: "unset",
        minWidth: 0,
        "& .MuiTabs-scrollButtons.Mui-disabled": {
            width: 0,
        },
    },
    tabsIndicator: {
        display: "none",
    },
    tabRoot: {
        textTransform: "initial",
        minWidth: "unset",
        minHeight: "unset",
        padding: "12px 16px",
        border: "1px solid transparent",
        borderRadius: "8px",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "normal",
        color: black400,
        "&:hover": {
            color: black500,
            opacity: 1,
        },
        "&$tabSelected": {
            backgroundColor: "#FFF",
            border: `1px solid ${greyishBlue200}`,
            color: black500,
        },
        "&:focus": {
            color: black500,
        },
    },
    tabSelected: {
        color: black500
    },
    filterLoading : {
        width: "100%",
        textAlign: "center",
        margin: "10px 0px 0px 0px",
    },
    filterBlueTitle: {
        fontSize: "14px",
        color: blue500,
        fontWeight: 600,
        marginBottom: "4px",
    },
    filterInColumn : {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "8px",
        // keeps each column at its natural width so the row scrolls instead of
        // squeezing the columns and wrapping their titles
        flexShrink: 0,
        color: "#000",
    },
    statusStockFilter:{
        display: "flex",
        alignItems: "flex-start",
        gap: "32px",
        maxWidth: "100%",
        overflowX: "auto",
        borderStyle: "inherit !important"
    },
    priceFilters: {
        display: "flex",
        alignItems: "flex-end",
        flexWrap: "wrap",
        gap: "16px",
    },
    priceFilterInput: {
        width: "120px",
        backgroundColor: "#FFF",
    },
    priceFilterApply: {
        // same look as the list toolbar's "Trier par" button (ListingSortButton)
        height: "40px",
        display: "inline-flex",
        alignItems: "center",
        padding: "12px 16px",
        backgroundColor: blue500,
        border: "none",
        borderRadius: "8px",
        color: "#fff",
        fontSize: "14px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: blue600,
        },
    },
    filters: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "8px",
    },
    filtersRow: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: "8px",
        maxWidth: "100%",
        overflowX: "auto",
        paddingBottom: "4px",
        "& > *": {
            flexShrink: 0,
        },
    },
    filterItem: {
        fontSize: "14px",
        fontWeight: 600,
        height: "40px",
        margin: 0,
        borderRadius: "999px",
        "& .MuiChip-label": {
            padding: "0 16px",
        },
        "&.MuiChip-outlined": {
            backgroundColor: "#FFF",
            border: `1px solid ${greyishBlue200}`,
            color: black500,
        },
        "&:not(.MuiChip-outlined)": {
            backgroundColor: blue500,
            color: "#FFF",
            "&:hover, &:focus": {
                backgroundColor: blue500,
            },
        },
    },
    categoriesFilterContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        width: "100%",
        overflowX: "scroll"
    },
    categoriesFilterColumn: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        borderWidth: "0px 1px 0px 0px",
        borderStyle:"solid",
        borderColor: greyishBlue100,
        overflowY: "scroll"
    },
});

export default filterMenuStyle;
